import React from 'react';
//gatsby
import { Link, graphql } from 'gatsby';
//seo
import Seo from 'gatsby-plugin-wpgraphql-seo';
//styles
import styled from 'styled-components';
import { rem } from 'polished';
import vars from 'components/styles/varss';
//components
import Layout from 'components/ui/layout';
import Container from 'components/ui/container';
import Heading from 'components/ui/heading';
import Icon from 'components/ui/icon';
import Small from 'components/resources/small';
//grid
import { Row, Col } from 'styled-bootstrap-grid';
//parser
import parse from "html-react-parser";

//styled
const ArticleArchiveWrap = styled.div`
  position: relative;
  padding-top: ${rem('100px')};
`;

const ArticleNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  > a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: ${rem('48px')};
    height: ${rem('48px')};
    margin-left: ${rem('10px')};
    margin-right: ${rem('10px')};
    border-radius: 50%;
    color: #fff;
    background-color: ${vars.colors.darkBlue};
    &:hover {
      background-color: #6F54F9;
      color: #fff;
    }
    &:not([href]):not([tabindex]) {
      color: ${vars.colors.grey4};
      background-color: ${vars.colors.grey1};
      &:hover {
        color: ${vars.colors.grey4};
      }
    }
  }
  strong {
    display: inline-block;
    margin-left: ${rem('10px')};
    margin-right: ${rem('10px')};
  }
`;

const ArticleCTA = styled.div`
  position: relative;
  margin-top: ${rem('100px')};
`;

const ArticleArchive = ({
  data,
  pageContext: {
    nextPagePath,
    previousPagePath,
    articlesCatTotalPages,
    pageNumber
  } }) => {

  const articles = data.allWpArticle.nodes;

  if (!articles.length) {
    return (
      <Layout
        isResources={true}
        headerBg={'#ffffff'}
        headerColor={'#071A2B'}>
        <Seo
          post={data.allWpArticleCategory.nodes[0]}
        />
        <ArticleArchiveWrap>
          <Container>
            <Heading as="h2" heading2 marginBottom="60px" style={{ textAlign: 'center' }}>No articles found.</Heading>
          </Container>
        </ArticleArchiveWrap>
      </Layout>
    )
  }

  return (
    <Layout
      isResources={true}
      headerBg={'#ffffff'}
      headerColor={'#071A2B'}>
      <Seo
        post={data.allWpArticleCategory.nodes[0]}
      />
      <ArticleArchiveWrap>
        <Container>
          <Heading as="h1" marginBottom="60px">{data.allWpArticleCategory.nodes[0].name}</Heading>
          <Row>
            {articles.map((article) => (
              <Col col xs={12} sm={6} md={4} key={article.id}>
                <Small post={article} withCategory />
              </Col>
            ))}
          </Row>
          <ArticleNav>
            <Link to={previousPagePath}><Icon icon="caret-left" size={12} /></Link>
            <strong>{pageNumber} of {articlesCatTotalPages}</strong>
            <Link to={nextPagePath}><Icon icon="caret-right" size={12} /></Link>
          </ArticleNav>
        </Container>
        <ArticleCTA className="wp-front">
          {!!data.wp.blogCtas.articlesCTA && (
            parse(data.wp.blogCtas.articlesCTA)
          )}
        </ArticleCTA>
      </ArticleArchiveWrap>
    </Layout>
  );
};

export const pageQuery = graphql`
  query ($offset: Int!, $postsPerPage: Int!, $slug: String!) {
    wp {
      readingSettings {
        postsPerPage
      }
      blogCtas {
        articlesCTA
      }
    }
    allWpArticle ( 
      limit: $postsPerPage, 
      skip: $offset
      filter: {articleCategories: {nodes: {elemMatch: {slug: {eq: $slug}}}}, status: {eq: "publish"}}
      ) {
      nodes {
        id
        title
        uri
        excerpt
        nodeType
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            sourceUrl
            srcSet
            altText
          }
        }
        articleCategories {
          nodes {
            uri
            name
            id
          }
        }
      }
    }
    allWpArticleCategory(filter: {slug: {eq: $slug}}) {
      nodes {
        id
        name
        seo {
          canonical
          cornerstone
          focuskw
          fullHead
          metaDesc
          metaKeywords
          metaRobotsNofollow
          metaRobotsNoindex
          opengraphAuthor
          opengraphDescription
          opengraphModifiedTime
          opengraphPublishedTime
          opengraphPublisher
          opengraphSiteName
          opengraphTitle
          opengraphType
          opengraphUrl
          title
          twitterDescription
          twitterTitle
        }
      }
    }
  }
`

export default ArticleArchive;